import React from 'react';
import { LoadingBar, StatTable } from 'components/Commons';
import cm from 'helpers/commons';
import _ from 'helpers/_.js';

const BookingStatsResult = ({ data }) => {
  let header = [
    { content: '날짜', textAlign: 'left' },
    { content: '제휴식당', textAlign: 'left' },
    { content: '식사시간', textAlign: 'left' },
    { content: '총 회사식대', textAlign: 'right' },
    { content: '총 정산금액', textAlign: 'right' },
    { content: '식사횟수', textAlign: 'right' },
    { content: '취소식대', textAlign: 'right' }
  ];

  let tabledata = null;

  if (data && data.contents.length > 0) {
    const { contents } = data;
    let newData = contents.map((content) => {
      let headerArr = [];
      let bodyArr = [];
      let obj = {};

      headerArr.push({
        content: content.sdate,
        colSpan: 7,
        textAlign: 'center'
      });

      const { stores } = content;

      stores.map((store) => {
        let rows = {};
        rows = {
          row: [
            { content: content.sdate, textAlign: 'left' },
            { content: store.store.name, textAlign: 'left' },
            { content: store.booking.name, textAlign: 'left' },
            { content: cm.numberComma(store.count.price), textAlign: 'right' },
            { content: cm.numberComma(store.count.companyprice), textAlign: 'right' },
            { content: store.count.booking, textAlign: 'right' },
            {
              content: store.count.cancel,
              textAlign: 'right',
              fontColor: '#ff0000'
            }
          ]
        };

        bodyArr.push(rows);
      });

      obj = {
        header: headerArr,
        body: bodyArr
      };

      return obj;
    });

    tabledata = newData;
  } else {
    tabledata = '예약 목록이 없습니다.';
  }

  let loading = '';
  if (!tabledata) {
    loading = <LoadingBar />;
  }

  return (
    <div className="store-stat-result table-container">
      {loading}
      <div className="table-box">
        <StatTable colWidth={[100, 300, 60, 100, 100, 100, 100]} header={header} data={tabledata} />
      </div>
    </div>
  );
};

export default BookingStatsResult;
